import { render, staticRenderFns } from "./DialogDefault.vue?vue&type=template&id=857de996"
import script from "./DialogDefault.vue?vue&type=script&lang=js"
export * from "./DialogDefault.vue?vue&type=script&lang=js"
import style0 from "./DialogDefault.vue?vue&type=style&index=0&id=857de996&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports